import { IInvoiceException } from './iinvoice-exception.interface';

export enum InvoiceDetailType {
	Instructional = 1,
	Admin = 2,
	Other = 3
}

export interface IInvoiceDetail {
	invoiceDetailID: number;
	invoiceID: number;
	instructorUserID: number;
	invoiceDetailTypeID: InvoiceDetailType;
	invoiceDetailType: string;
	invoiceDetailCategoryID: number;
	invoiceDetailCategory: string;
	hours: number;
	rate: number;
	amount: number;
	lessonID?: number;
	lessonStartDate?: string;
	learnerName?: string;
	languageLevel?: string;
	hasExceptions: boolean;
	isArchived: boolean;
	notes?: string;
	createDate: string;
	createdBy: number;
	lastModifiedDate?: string;
	lastModifiedBy?: number;

	exceptions?: IInvoiceException[];
}
